export const dateFormat = (date: string) => {
  return date.split("-").reverse().join("/");
};

export const omitWhiteSpace = (str: string) => {
  return str.replace(/ +/g, "");
};
